import { useState, useEffect } from "react";
import { CognitoUserPool, CognitoUser, AuthenticationDetails, CognitoUserAttribute } from "amazon-cognito-identity-js";

const T = {
  bg:"#0A0E1A", surface:"#111827", card:"#1C2333", border:"#243044",
  accent:"#3B82F6", amber:"#60A5FA", text:"#F1F5F9", sub:"#6B82A0",
  muted:"#2D3A50", success:"#10B981", danger:"#EF4444", blue:"#3B82F6",
  purple:"#8B5CF6", grad:"linear-gradient(135deg,#0A1628,#1C2333)",
};

const HST_RATE = 0.13;
const API_URL = "https://drivemind.org/api";

const POOL = new CognitoUserPool({
  UserPoolId: "us-east-1_S6ez7w3nY",
  ClientId: "4d1pltag4118hsa4qt6dg3jv4f"
});

const useIsMobile = () => {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handler = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener("resize", handler);
    return () => window.removeEventListener("resize", handler);
  }, []);
  return isMobile;
};

const callClaude = async (prompt) => {
  try {
    const res = await fetch(API_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ action: "ai_query", payload: { prompt } })
    });
    const data = await res.json();
    return data.result || "Error loading data.";
  } catch(e) {
    return "Error loading data.";
  }
};

const DEMO_CUSTOMERS = [
  {id:1,name:"Carter James",phone:"111-222-3333",email:"carter.james@gmail.com",interest:"2024 Honda CR-V EX-L",budget:"$45,000",status:"hot",source:"walk-in",lastContact:"2h ago",notes:"Very interested. Test drove CR-V EX-L in Sonic Grey. Bringing spouse back Saturday.",trade:"2019 Toyota Camry SE (88k km)",tradeValue:13500,visits:2,soldVehicle:"",appointment:"2026-05-23T10:00",apptNote:"Spouse visit — close the deal",contactPref:"phone"},
  {id:2,name:"Sharma Priya",phone:"111-222-3333",email:"sharma.priya@outlook.com",interest:"2024 Honda Civic Sport",budget:"$32,000",status:"follow-up",source:"internet",lastContact:"1 day ago",notes:"Comparing with Toyota Corolla. Responded well to safety features.",trade:null,tradeValue:0,visits:1,soldVehicle:"",appointment:null,apptNote:"",contactPref:"email"},
  {id:3,name:"O'Brien Mike",phone:"111-222-3333",email:"obrien.mike@rogers.com",interest:"2024 Honda Pilot Touring",budget:"$62,000",status:"hot",source:"referral",lastContact:"3h ago",notes:"Referred by Kim Sarah. Family of 5. Ready to buy this week.",trade:"2020 Ford Explorer XLT (52k km)",tradeValue:21000,visits:1,soldVehicle:"",appointment:"2026-05-21T14:30",apptNote:"Test drive Pilot Touring",contactPref:"phone"},
  {id:4,name:"Kim Sarah",phone:"111-222-3333",email:"kim.sarah@bell.net",interest:"2024 Honda Accord Sport",budget:"$42,000",status:"sold",source:"service drive",lastContact:"May 18",notes:"Came in for oil change, drove out in a new Accord.",trade:null,tradeValue:0,visits:3,soldVehicle:"2024 Honda Accord Sport · Platinum White · #H2402",appointment:null,apptNote:"",contactPref:"text"},
  {id:5,name:"Thompson Derek",phone:"111-222-3333",email:"thompson.derek@hotmail.com",interest:"2024 Honda Pilot TrailSport",budget:"$58,000",status:"follow-up",source:"walk-in",lastContact:"2 days ago",notes:"Outdoors enthusiast. Payment slightly high.",trade:"2019 Ford F-150 XLT (91k km)",tradeValue:24000,visits:2,soldVehicle:"",appointment:"2026-05-22T11:00",apptNote:"Review revised numbers",contactPref:"phone"},
  {id:6,name:"Thompson Emma",phone:"111-222-3333",email:"thompson.emma@gmail.com",interest:"2024 Honda CR-V Hybrid",budget:"$54,000",status:"follow-up",source:"walk-in",lastContact:"3h ago",notes:"Eco-conscious buyer. Interested in hybrid savings.",trade:"2018 Honda Civic EX (71k km)",tradeValue:9500,visits:1,soldVehicle:"",appointment:null,apptNote:"",contactPref:"email"},
  {id:7,name:"Park Kevin",phone:"111-222-3333",email:"park.kevin@rogers.com",interest:"2024 Honda Ridgeline Sport",budget:"$52,000",status:"fresh",source:"internet",lastContact:"Just now",notes:"First visit. Asked about towing capacity.",trade:null,tradeValue:0,visits:1,soldVehicle:"",appointment:null,apptNote:"",contactPref:"text"},
  {id:8,name:"Santos Maria",phone:"111-222-3333",email:"santos.maria@gmail.com",interest:"2023 Honda HR-V LX",budget:"$31,000",status:"sold",source:"internet",lastContact:"May 12",notes:"First car purchase. Financed 72 months.",trade:null,tradeValue:0,visits:2,soldVehicle:"2023 Honda HR-V LX · Aegean Blue · #U2302",appointment:null,apptNote:"",contactPref:"email"},
];

const DEMO_DEALS = [
  {id:1,customer:"Kim Sarah",vehicle:"2024 Honda Accord Sport",type:"finance",status:"delivered",front:2800,back:1850,total:4650,date:"May 18",stock:"H2402"},
  {id:2,customer:"Walsh Jennifer",vehicle:"2023 Honda Civic LX",type:"finance",status:"delivered",front:1200,back:950,total:2150,date:"May 15",stock:"U2301"},
  {id:3,customer:"Walsh Tom",vehicle:"2024 Honda CR-V EX",type:"lease",status:"delivered",front:1800,back:1100,total:2900,date:"May 14",stock:"H2401"},
  {id:4,customer:"Santos Maria",vehicle:"2023 Honda HR-V LX",type:"finance",status:"delivered",front:1500,back:750,total:2250,date:"May 12",stock:"U2302"},
  {id:5,customer:"Thompson Derek",vehicle:"2024 Honda Pilot TrailSport",type:"finance",status:"pending",front:3200,back:1400,total:4600,date:"May 21",stock:"H2405"},
  {id:6,customer:"Rivera Ana",vehicle:"2023 Honda Civic Sport",type:"lease",status:"pending",front:1100,back:680,total:1780,date:"May 20",stock:"U2303"},
];

const DEMO_INVENTORY = [
  {id:1,year:2024,make:"Honda",model:"CR-V",trim:"EX-L AWD",color:"Sonic Grey Pearl",price:44990,mileage:18,days:8,stock:"H2401",type:"new"},
  {id:2,year:2024,make:"Honda",model:"Accord",trim:"Sport",color:"Platinum White Pearl",price:38990,mileage:5,days:3,stock:"H2402",type:"new"},
  {id:3,year:2024,make:"Honda",model:"Pilot",trim:"Touring AWD",color:"Radiant Red Metallic",price:58990,mileage:22,days:5,stock:"H2403",type:"new"},
  {id:4,year:2024,make:"Honda",model:"CR-V",trim:"Hybrid Sport-L",color:"Aegean Blue Metallic",price:52990,mileage:12,days:11,stock:"H2404",type:"new"},
  {id:5,year:2024,make:"Honda",model:"Pilot",trim:"TrailSport AWD",color:"Lunar Silver Metallic",price:57490,mileage:30,days:18,stock:"H2405",type:"new"},
  {id:6,year:2022,make:"Toyota",model:"Camry",trim:"XSE V6",color:"Midnight Black",price:31990,mileage:34200,days:31,stock:"U2201",type:"used"},
  {id:7,year:2021,make:"Honda",model:"CR-V",trim:"EX AWD",color:"Modern Steel Metallic",price:27490,mileage:52100,days:24,stock:"U2202",type:"used"},
];

const LEASES = [
  {id:1,customer:"Lang Robert",phone:"111-222-3333",vehicle:"2022 Honda CR-V EX AWD",maturity:"30 days",payment:488,equity:"+$2,400",urgency:"high"},
  {id:2,customer:"Davis Mark",phone:"111-222-3333",vehicle:"2022 Honda Accord EX-L",maturity:"45 days",payment:524,equity:"+$3,100",urgency:"high"},
  {id:3,customer:"Wu Jennifer",phone:"111-222-3333",vehicle:"2021 Honda Civic Sport",maturity:"60 days",payment:328,equity:"+$900",urgency:"medium"},
  {id:4,customer:"Park Lisa",phone:"111-222-3333",vehicle:"2021 Honda HR-V LX",maturity:"75 days",payment:294,equity:"-$380",urgency:"medium"},
];

const SERVICE = [
  {id:1,customer:"Foster Brian",vehicle:"2020 Honda Civic (89k km)",equity:"+$3,400",service:"Brake service",bill:"$485"},
  {id:2,customer:"White Nancy",vehicle:"2019 Honda CR-V (102k km)",equity:"+$1,800",service:"Oil change",bill:"$189"},
  {id:3,customer:"Mitchell Gary",vehicle:"2021 Honda Accord (61k km)",equity:"+$5,200",service:"Annual inspection",bill:"$175"},
  {id:4,customer:"Lee Sandra",vehicle:"2020 Honda Pilot (78k km)",equity:"+$4,100",service:"Transmission service",bill:"$520"},
];

const STEPS = [
  {n:1,t:"Meet & Greet",d:"First impressions set everything. Be warm and focus entirely on the customer."},
  {n:2,t:"Information Gathering",d:"Ask open-ended questions. Listen more than you talk."},
  {n:3,t:"Vehicle Selection",d:"Select 1-2 vehicles based on what you learned. Guide them."},
  {n:4,t:"Product Presentation",d:"Walk around with purpose. Highlight relevant features."},
  {n:5,t:"Test Drive",d:"The test drive sells the car, not you. Let them experience it."},
  {n:6,t:"Trade-In Appraisal",d:"Separate the trade from the deal. Make them feel valued."},
  {n:7,t:"The Write-Up",d:"Get them to the desk. Numbers on paper create commitment."},
  {n:8,t:"Negotiation",d:"Defend your value. Always trade, never give."},
  {n:9,t:"F&I Introduction",d:"Set the Finance Manager up for success."},
  {n:10,t:"Delivery",d:"The delivery begins your next sale. Get the review and referrals."},
];

const DELIVERY_ITEMS = [
  "Finance documents signed and complete",
  "Insurance verified and on file",
  "Trade-in title / ownership transferred",
  "Vehicle detailed and full tank of gas",
  "All keys, manuals, and floor mats present",
  "Full walkaround of all features completed",
  "Honda Connect app set up with customer",
  "Service intervals and warranty explained",
  "Google review request sent",
  "Referral conversation completed",
];

const OBJECTIONS = [
  "The payment is too high",
  "I want to think about it",
  "I'm just looking today",
  "Let me talk to my spouse first",
  "I can get it cheaper at another dealer",
  "Your trade-in offer is too low",
  "I don't want an extended warranty",
  "I need to sell my car first",
];

const SC = {hot:"#EF4444","follow-up":"#F59E0B",fresh:"#3B82F6",sold:"#10B981",lost:"#6B7280"};
const SL = {hot:"Hot","follow-up":"Follow Up",fresh:"Fresh Lead",sold:"Sold",lost:"Lost"};
const SE = {hot:"🔥","follow-up":"📞",fresh:"✨",sold:"✅",lost:"❌"};
const fmt=(n)=>`$${Math.round(n).toLocaleString()}`;
const formatDate=(d)=>{if(!d)return null;return new Date(d).toLocaleDateString("en-US",{weekday:"short",month:"short",day:"numeric",hour:"2-digit",minute:"2-digit"});};
const isUpcoming=(d)=>d&&new Date(d)>new Date();

function AuthModal({onClose,onLogin}){
  const [mode,setMode]=useState("login");
  const [name,setName]=useState("");
  const [email,setEmail]=useState("");
  const [password,setPassword]=useState("");
  const [code,setCode]=useState("");
  const [error,setError]=useState("");
  const [loading,setLoading]=useState(false);

  const inp={background:"#0A0E1A",border:"1px solid #243044",borderRadius:10,padding:"12px 16px",color:"#F1F5F9",fontSize:14,width:"100%",boxSizing:"border-box",outline:"none",fontFamily:"inherit",marginBottom:12};

  const doRegister=()=>{
    if(!name||!email||!password){setError("Please fill in all fields.");return;}
    setLoading(true);setError("");
    const attrs=[new CognitoUserAttribute({Name:"name",Value:name})];
    POOL.signUp(email,password,attrs,null,(err)=>{
      setLoading(false);
      if(err){setError(err.message||"Registration failed.");return;}
      setMode("verify");
    });
  };

  const doVerify=()=>{
    if(!code){setError("Please enter the verification code.");return;}
    setLoading(true);setError("");
    const user=new CognitoUser({Username:email,Pool:POOL});
    user.confirmRegistration(code,true,(err)=>{
      setLoading(false);
      if(err){setError(err.message||"Verification failed.");return;}
      setMode("login");
      setError("✅ Account verified! Please sign in.");
    });
  };

  const doLogin=()=>{
    if(!email||!password){setError("Please enter email and password.");return;}
    setLoading(true);setError("");
    const user=new CognitoUser({Username:email,Pool:POOL});
    const auth=new AuthenticationDetails({Username:email,Password:password});
    user.authenticateUser(auth,{
      onSuccess:(session)=>{
        setLoading(false);
        const payload=session.getIdToken().payload;
        onLogin({email,name:payload.name||email.split("@")[0],token:session.getIdToken().getJwtToken()});
        onClose();
      },
      onFailure:(err)=>{
        setLoading(false);
        setError(err.message||"Login failed.");
      }
    });
  };

  const doForgot=()=>{
    if(!email){setError("Please enter your email.");return;}
    setLoading(true);setError("");
    const user=new CognitoUser({Username:email,Pool:POOL});
    user.forgotPassword({
      onSuccess:()=>{setLoading(false);setMode("resetcode");},
      onFailure:(err)=>{setLoading(false);setError(err.message);}
    });
  };

  const doReset=()=>{
    if(!code||!password){setError("Please fill in all fields.");return;}
    setLoading(true);setError("");
    const user=new CognitoUser({Username:email,Pool:POOL});
    user.confirmPassword(code,password,{
      onSuccess:()=>{setLoading(false);setMode("login");setError("✅ Password reset! Please sign in.");},
      onFailure:(err)=>{setLoading(false);setError(err.message);}
    });
  };

  const doResend=()=>{
    const user=new CognitoUser({Username:email,Pool:POOL});
    user.resendConfirmationCode((err)=>{
      if(err){setError(err.message);}
      else{setError("✅ New code sent! Check your email and spam folder.");}
    });
  };

  return(
    <div style={{position:"fixed",top:0,left:0,right:0,bottom:0,background:"rgba(0,0,0,0.7)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center",padding:20}} onClick={onClose}>
      <div onClick={e=>e.stopPropagation()} style={{background:"#111827",border:"1px solid #243044",borderRadius:20,padding:32,width:"100%",maxWidth:400,fontFamily:"'DM Sans',sans-serif"}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:24}}>
          <div>
            <div style={{fontSize:22,fontWeight:800,color:"#F1F5F9"}}>
              {mode==="login"?"Sign In":mode==="register"?"Create Account":mode==="verify"?"Verify Email":mode==="forgot"?"Reset Password":"Set New Password"}
            </div>
            <div style={{fontSize:13,color:"#6B82A0",marginTop:2}}>
              {mode==="login"?"Access your personal dashboard":mode==="register"?"Start your free DriveMind account":mode==="verify"?"Check your email for the code":mode==="forgot"?"Enter your email to reset password":"Enter the code and your new password"}
            </div>
          </div>
          <button onClick={onClose} style={{background:"none",border:"none",color:"#6B82A0",cursor:"pointer",fontSize:20,padding:4}}>✕</button>
        </div>

        {error&&(
          <div style={{background:error.startsWith("✅")?`${T.success}15`:`${T.danger}15`,border:`1px solid ${error.startsWith("✅")?T.success:T.danger}30`,borderRadius:10,padding:"10px 14px",fontSize:13,color:error.startsWith("✅")?T.success:T.danger,marginBottom:14}}>
            {error}
          </div>
        )}

        {mode==="login"&&<>
          <input value={email} onChange={e=>setEmail(e.target.value)} placeholder="Email address" type="email" style={inp}/>
          <input value={password} onChange={e=>setPassword(e.target.value)} placeholder="Password" type="password" style={inp} onKeyDown={e=>e.key==="Enter"&&doLogin()}/>
          <button onClick={doLogin} disabled={loading} style={{width:"100%",background:"#3B82F6",border:"none",borderRadius:12,padding:"13px",color:"#fff",cursor:"pointer",fontSize:15,fontWeight:800,fontFamily:"inherit",marginBottom:14}}>
            {loading?"Signing in...":"Sign In"}
          </button>
          <div style={{textAlign:"center",fontSize:13,color:"#6B82A0",marginBottom:8}}>
            Don't have an account? <span onClick={()=>{setMode("register");setError("");}} style={{color:"#3B82F6",cursor:"pointer",fontWeight:700}}>Create one free</span>
          </div>
          <div style={{textAlign:"center"}}>
            <span onClick={()=>{setMode("forgot");setError("");}} style={{color:"#6B82A0",cursor:"pointer",fontSize:12}}>Forgot password?</span>
          </div>
        </>}

        {mode==="register"&&<>
          <input value={name} onChange={e=>setName(e.target.value)} placeholder="Your full name" type="text" style={inp}/>
          <input value={email} onChange={e=>setEmail(e.target.value)} placeholder="Email address" type="email" style={inp}/>
          <input value={password} onChange={e=>setPassword(e.target.value)} placeholder="Password (min 8 characters)" type="password" style={inp}/>
          <button onClick={doRegister} disabled={loading} style={{width:"100%",background:"#3B82F6",border:"none",borderRadius:12,padding:"13px",color:"#fff",cursor:"pointer",fontSize:15,fontWeight:800,fontFamily:"inherit",marginBottom:14}}>
            {loading?"Creating account...":"Create Free Account"}
          </button>
          <div style={{textAlign:"center",fontSize:13,color:"#6B82A0"}}>
            Already have an account? <span onClick={()=>{setMode("login");setError("");}} style={{color:"#3B82F6",cursor:"pointer",fontWeight:700}}>Sign in</span>
          </div>
        </>}

        {mode==="verify"&&<>
          <div style={{fontSize:13,color:"#6B82A0",marginBottom:14}}>We sent a 6-digit code to <strong style={{color:"#F1F5F9"}}>{email}</strong>. Check your spam folder too.</div>
          <input value={code} onChange={e=>setCode(e.target.value)} placeholder="Enter verification code" type="text" style={{...inp,textAlign:"center",fontSize:22,letterSpacing:6}} onKeyDown={e=>e.key==="Enter"&&doVerify()}/>
          <button onClick={doVerify} disabled={loading} style={{width:"100%",background:"#3B82F6",border:"none",borderRadius:12,padding:"13px",color:"#fff",cursor:"pointer",fontSize:15,fontWeight:800,fontFamily:"inherit",marginBottom:10}}>
            {loading?"Verifying...":"Verify Email"}
          </button>
          <div style={{textAlign:"center",fontSize:13,color:"#6B82A0",marginBottom:8}}>
            Didn't receive it? <span onClick={doResend} style={{color:"#3B82F6",cursor:"pointer",fontWeight:700}}>Resend code</span>
          </div>
          <div style={{textAlign:"center",fontSize:13,color:"#6B82A0"}}>
            <span onClick={()=>{setMode("register");setError("");}} style={{color:"#6B82A0",cursor:"pointer"}}>Go back</span>
          </div>
        </>}

        {mode==="forgot"&&<>
          <input value={email} onChange={e=>setEmail(e.target.value)} placeholder="Email address" type="email" style={inp}/>
          <button onClick={doForgot} disabled={loading} style={{width:"100%",background:"#3B82F6",border:"none",borderRadius:12,padding:"13px",color:"#fff",cursor:"pointer",fontSize:15,fontWeight:800,fontFamily:"inherit",marginBottom:14}}>
            {loading?"Sending...":"Send Reset Code"}
          </button>
          <div style={{textAlign:"center",fontSize:13,color:"#6B82A0"}}>
            <span onClick={()=>{setMode("login");setError("");}} style={{color:"#3B82F6",cursor:"pointer"}}>Back to sign in</span>
          </div>
        </>}

        {mode==="resetcode"&&<>
          <div style={{fontSize:13,color:"#6B82A0",marginBottom:14}}>Enter the code sent to <strong style={{color:"#F1F5F9"}}>{email}</strong> and your new password.</div>
          <input value={code} onChange={e=>setCode(e.target.value)} placeholder="Reset code" type="text" style={inp}/>
          <input value={password} onChange={e=>setPassword(e.target.value)} placeholder="New password (min 8 characters)" type="password" style={inp}/>
          <button onClick={doReset} disabled={loading} style={{width:"100%",background:"#3B82F6",border:"none",borderRadius:12,padding:"13px",color:"#fff",cursor:"pointer",fontSize:15,fontWeight:800,fontFamily:"inherit",marginBottom:14}}>
            {loading?"Resetting...":"Reset Password"}
          </button>
          <div style={{textAlign:"center",fontSize:13,color:"#6B82A0"}}>
            <span onClick={()=>{setMode("login");setError("");}} style={{color:"#3B82F6",cursor:"pointer"}}>Back to sign in</span>
          </div>
        </>}
      </div>
    </div>
  );
}

export default function App(){
  const isMobile=useIsMobile();
  const [user,setUser]=useState(null);
  const [showAuth,setShowAuth]=useState(false);
  const [showUserMenu,setShowUserMenu]=useState(false);

  useEffect(()=>{
    const cognitoUser=POOL.getCurrentUser();
    if(cognitoUser){
      cognitoUser.getSession((err,session)=>{
        if(!err&&session.isValid()){
          const payload=session.getIdToken().payload;
          setUser({email:cognitoUser.getUsername(),name:payload.name||cognitoUser.getUsername().split("@")[0]});
        }
      });
    }
  },[]);

  const doLogout=()=>{
    const cognitoUser=POOL.getCurrentUser();
    if(cognitoUser)cognitoUser.signOut();
    setUser(null);
    setShowUserMenu(false);
  };

  return(
    <>
      <link href="https://fonts.googleapis.com/css2?family=DM+Sans:opsz,wght@9..40,400;9..40,500;9..40,600;9..40,700;9..40,800&display=swap" rel="stylesheet"/>
      {showAuth&&<AuthModal onClose={()=>setShowAuth(false)} onLogin={setUser}/>}
      <MainApp user={user} isMobile={isMobile} onShowAuth={()=>setShowAuth(true)} onLogout={doLogout} showUserMenu={showUserMenu} setShowUserMenu={setShowUserMenu}/>
    </>
  );
}

function MainApp({user,isMobile,onShowAuth,onLogout,showUserMenu,setShowUserMenu}){
  const [tab,setTab]=useState("home");
  const [toolTab,setToolTab]=useState("calculator");
  const [aiTab,setAiTab]=useState("coach");
  const [dealTab,setDealTab]=useState("pipeline");

  const getCustomers=()=>{if(user){const s=localStorage.getItem(`dm_customers_${user.email}`);if(s)return JSON.parse(s);}return DEMO_CUSTOMERS;};
  const getDeals=()=>{if(user){const s=localStorage.getItem(`dm_deals_${user.email}`);if(s)return JSON.parse(s);}return DEMO_DEALS;};
  const getInventory=()=>{if(user){const s=localStorage.getItem(`dm_inventory_${user.email}`);if(s)return JSON.parse(s);}return DEMO_INVENTORY;};

  const [customers,setCustomers]=useState(getCustomers);
  const [deals,setDeals]=useState(getDeals);
  const [inventory,setInventory]=useState(getInventory);
  const [goalUnits,setGoalUnits]=useState(()=>user?parseInt(localStorage.getItem(`dm_goalUnits_${user.email}`))||15:15);
  const [goalGross,setGoalGross]=useState(()=>user?parseInt(localStorage.getItem(`dm_goalGross_${user.email}`))||45000:45000);

  useEffect(()=>{setCustomers(getCustomers());setDeals(getDeals());setInventory(getInventory());},[user]);
  useEffect(()=>{if(user)localStorage.setItem(`dm_customers_${user.email}`,JSON.stringify(customers));},[customers,user]);
  useEffect(()=>{if(user)localStorage.setItem(`dm_deals_${user.email}`,JSON.stringify(deals));},[deals,user]);
  useEffect(()=>{if(user)localStorage.setItem(`dm_inventory_${user.email}`,JSON.stringify(inventory));},[inventory,user]);
  useEffect(()=>{if(user)localStorage.setItem(`dm_goalUnits_${user.email}`,goalUnits);},[goalUnits,user]);
  useEffect(()=>{if(user)localStorage.setItem(`dm_goalGross_${user.email}`,goalGross);},[goalGross,user]);

  const [selCust,setSelCust]=useState(null);
  const [addMode,setAddMode]=useState(false);
  const [editMode,setEditMode]=useState(false);
  const [editData,setEditData]=useState(null);
  const [showDeleteConfirm,setShowDeleteConfirm]=useState(false);
  const [nc,setNc]=useState({name:"",phone:"",email:"",interest:"",budget:"",source:"walk-in",notes:"",trade:"",tradeValue:0,contactPref:"phone"});
  const [calcMode,setCalcMode]=useState("finance");
  const [cv,setCv]=useState({price:44990,down:5000,rate:6.9,term:60,residual:55,tradeValue:0,includeHST:true});
  const [briefing,setBriefing]=useState("");
  const [briefLoad,setBriefLoad]=useState(false);
  const [briefDone,setBriefDone]=useState(false);
  const [obj,setObj]=useState("");
  const [coachResp,setCoachResp]=useState("");
  const [coachLoad,setCoachLoad]=useState(false);
  const [custMsgType,setCustMsgType]=useState("follow-up");
  const [custMsg,setCustMsg]=useState("");
  const [custMsgLoad,setCustMsgLoad]=useState(false);
  const [insightText,setInsightText]=useState("");
  const [insightLoad,setInsightLoad]=useState(false);
  const [lsId,setLsId]=useState(null);
  const [lsText,setLsText]=useState("");
  const [lsLoad,setLsLoad]=useState(false);
  const [invSearch,setInvSearch]=useState("");
  const [cSearch,setCSearch]=useState("");
  const [cFilter,setCFilter]=useState("all");
  const [delivery,setDelivery]=useState(new Array(DELIVERY_ITEMS.length).fill(false));
  const [showAppt,setShowAppt]=useState(false);
  const [apptDate,setApptDate]=useState("");
  const [apptNote,setApptNote]=useState("");
  const [showSoldForm,setShowSoldForm]=useState(false);
  const [soldVehicleInput,setSoldVehicleInput]=useState("");
  const [selStep,setSelStep]=useState(null);
  const [stepDetail,setStepDetail]=useState("");
  const [stepLoad,setStepLoad]=useState(false);
  const [chatMessages,setChatMessages]=useState([{role:"ai",text:"Hi! I'm your DriveMind AI assistant. Ask me anything about sales, customers, objections, or dealership operations."}]);
  const [chatInput,setChatInput]=useState("");
  const [chatLoad,setChatLoad]=useState(false);
  const [showNewDeal,setShowNewDeal]=useState(false);
  const [newDeal,setNewDeal]=useState({customer:"",vehicle:"",type:"finance",front:0,back:0,stock:""});
  const [showAddInv,setShowAddInv]=useState(false);
  const [newInv,setNewInv]=useState({year:2024,make:"Honda",model:"",trim:"",color:"",price:0,mileage:0,days:0,stock:"",type:"new"});
  const [editInv,setEditInv]=useState(null);

  const UNITS_SOLD=deals.filter(d=>d.status==="delivered").length;
  const GROSS_MTD=deals.filter(d=>d.status==="delivered").reduce((a,d)=>a+d.total,0);
  const CLOSING_RATIO=customers.filter(c=>c.status!=="fresh").length>0?Math.round((deals.length/customers.filter(c=>c.status!=="fresh").length)*100):0;
  const displayName=user?user.name:"Alex";

  useEffect(()=>{
    if(tab==="home"&&!briefDone&&!briefLoad){
      setBriefLoad(true);
      callClaude(`You are an AI assistant for ${displayName}, a car salesperson at a Honda dealership in Ontario Canada. Generate a sharp motivating morning briefing under 130 words. Start with one powerful motivating sentence. Then 3 bullet points for top priority actions today. Context: ${UNITS_SOLD} deals delivered this month goal ${goalUnits} units. ${customers.filter(c=>c.status==="hot").length} hot leads. ${deals.filter(d=>d.status==="pending").length} deals pending. Direct energetic action focused. Plain text only.`)
        .then(r=>{setBriefing(r);setBriefDone(true);setBriefLoad(false);});
    }
  },[tab,briefDone,briefLoad]);

  const hstAmount=cv.price*HST_RATE;
  const tradeHSTSaving=cv.tradeValue*HST_RATE;
  const taxedPrice=cv.includeHST?cv.price*(1+HST_RATE):cv.price;
  const netPrice=taxedPrice-cv.tradeValue;
  const fp=()=>{const principal=netPrice-cv.down;const r=cv.rate/100/12,n=cv.term;if(principal<=0)return 0;return r===0?Math.round(principal/n):Math.round(principal*r*Math.pow(1+r,n)/(Math.pow(1+r,n)-1));};
  const lp=()=>{const rv=cv.price*(cv.residual/100);const rvWithHST=cv.includeHST?rv*(1+HST_RATE):rv;const d=(netPrice-cv.down-rvWithHST)/cv.term;const f=(netPrice-cv.down+rvWithHST)*(cv.rate/100/12);return Math.round(Math.max(d+f,0));};

  const navTo=(t)=>{setTab(t);setSelCust(null);setAddMode(false);setEditMode(false);setShowAppt(false);setShowSoldForm(false);setShowDeleteConfirm(false);setShowNewDeal(false);setShowAddInv(false);setEditInv(null);};
  const updateCust=(id,fields)=>{setCustomers(p=>p.map(c=>c.id===id?{...c,...fields}:c));setSelCust(p=>p?{...p,...fields}:p);};
  const deleteCust=(id)=>{setCustomers(p=>p.filter(c=>c.id!==id));setSelCust(null);setShowDeleteConfirm(false);setEditMode(false);};
  const addDeal=()=>{if(!newDeal.customer||!newDeal.vehicle)return;const total=(parseInt(newDeal.front)||0)+(parseInt(newDeal.back)||0);setDeals(p=>[...p,{...newDeal,id:Date.now(),status:"pending",total,date:"Today",front:parseInt(newDeal.front)||0,back:parseInt(newDeal.back)||0}]);setNewDeal({customer:"",vehicle:"",type:"finance",front:0,back:0,stock:""});setShowNewDeal(false);};
  const addInventory=()=>{if(!newInv.model||!newInv.stock)return;setInventory(p=>[...p,{...newInv,id:Date.now(),price:parseInt(newInv.price)||0,mileage:parseInt(newInv.mileage)||0,days:parseInt(newInv.days)||0,year:parseInt(newInv.year)||2024}]);setNewInv({year:2024,make:"Honda",model:"",trim:"",color:"",price:0,mileage:0,days:0,stock:"",type:"new"});setShowAddInv(false);};
  const removeInventory=(id)=>setInventory(p=>p.filter(v=>v.id!==id));
  const updateInventory=(id,fields)=>setInventory(p=>p.map(v=>v.id===id?{...v,...fields}:v));

  const loadStepDetail=async(step)=>{
    setSelStep(step);setStepLoad(true);setStepDetail("");
    const r=await callClaude(`You are an expert Honda automotive sales trainer. Give a detailed practical guide for the "${step.t}" step. Include: 1) Why this step matters, 2) What to do and say, 3) Common mistakes, 4) One powerful tip. Under 250 words. Plain text with bullets.`);
    setStepDetail(r);setStepLoad(false);
  };

  const sendChat=async()=>{
    if(!chatInput.trim())return;
    const userMsg={role:"user",text:chatInput};
    setChatMessages(p=>[...p,userMsg]);
    setChatInput("");
    setChatLoad(true);
    const r=await callClaude(`You are DriveMind AI for car dealership salespeople. Answer: ${chatInput}. Under 150 words. Practical and direct.`);
    setChatMessages(p=>[...p,{role:"ai",text:r}]);
    setChatLoad(false);
  };

  const inp={background:T.surface,border:`1px solid ${T.border}`,borderRadius:10,padding:"10px 12px",color:T.text,fontSize:14,width:"100%",boxSizing:"border-box",outline:"none",fontFamily:"inherit"};
  const lbl={fontSize:12,color:T.sub,marginBottom:6,display:"block",textTransform:"uppercase",letterSpacing:1};
  const Card=({children,style={}})=><div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:16,padding:isMobile?14:20,marginBottom:16,...style}}>{children}</div>;
  const SecTitle=({text,color})=>{const c=color||T.accent;return <div style={{fontSize:11,color:c,textTransform:"uppercase",letterSpacing:2.5,fontWeight:700,marginBottom:14,display:"flex",alignItems:"center",gap:8}}><div style={{width:5,height:5,borderRadius:"50%",background:c,boxShadow:`0 0 7px ${c}`}}/>{text}</div>;};
  const Pill=({label,active,onClick,color})=>{const c=color||T.accent;return <button onClick={onClick} style={{padding:isMobile?"6px 12px":"8px 16px",borderRadius:100,border:`1px solid ${active?c:T.border}`,background:active?`${c}20`:"transparent",color:active?c:T.sub,cursor:"pointer",fontSize:isMobile?11:13,fontWeight:active?700:400,fontFamily:"inherit",whiteSpace:"nowrap"}}>{label}</button>;};
  const AiBtn=({label,loading,onClick,color})=>{const c=color||T.purple;return <button onClick={onClick} style={{width:"100%",background:`${c}15`,border:`1px solid ${c}40`,borderRadius:12,padding:"14px",color:c,cursor:"pointer",fontSize:15,fontWeight:700,fontFamily:"inherit",display:"flex",alignItems:"center",justifyContent:"center",gap:8}}><span>✦</span>{loading?"Thinking...":label}</button>;};
  const RespBox=({text,color})=>{const c=color||T.purple;return <div style={{background:T.surface,border:`1px solid ${c}25`,borderRadius:12,padding:16,fontSize:14,color:T.sub,lineHeight:1.8,whiteSpace:"pre-wrap",marginTop:14}}>{text}</div>;};
  const Toggle=({checked,onChange})=>(
    <div style={{display:"flex",alignItems:"center",gap:10,cursor:"pointer"}} onClick={()=>onChange(!checked)}>
      <div style={{width:44,height:24,borderRadius:100,background:checked?T.accent:T.muted,position:"relative",transition:"all .2s",flexShrink:0}}>
        <div style={{width:18,height:18,borderRadius:"50%",background:"#fff",position:"absolute",top:3,left:checked?23:3,transition:"all .2s"}}/>
      </div>
    </div>
  );
  const g=(cols)=>isMobile?"1fr":`repeat(${cols},1fr)`;
  const pad=isMobile?16:24;

  const renderHome=()=>{
    const hot=customers.filter(c=>["hot","follow-up"].includes(c.status));
    const upcoming=customers.filter(c=>c.appointment&&isUpcoming(c.appointment));
    const pace=Math.min(Math.round((UNITS_SOLD/goalUnits)*100),100);
    return(
      <div style={{padding:pad}}>
        {!user&&(
          <div style={{background:`${T.accent}12`,border:`1px solid ${T.accent}30`,borderRadius:14,padding:"14px 20px",marginBottom:20,display:"flex",justifyContent:"space-between",alignItems:"center",flexWrap:"wrap",gap:10}}>
            <div>
              <div style={{fontSize:14,fontWeight:700,color:T.accent}}>👋 Welcome to DriveMind Demo</div>
              <div style={{fontSize:13,color:T.sub,marginTop:2}}>You are viewing sample data. Sign in to save your own customers, deals, and goals.</div>
            </div>
            <button onClick={onShowAuth} style={{background:T.accent,border:"none",borderRadius:10,padding:"10px 20px",color:"#fff",cursor:"pointer",fontSize:13,fontWeight:700,fontFamily:"inherit",flexShrink:0}}>Sign In Free</button>
          </div>
        )}
        <div style={{marginBottom:20}}>
          <div style={{fontSize:12,color:T.sub,letterSpacing:3,textTransform:"uppercase",marginBottom:4}}>
            {new Date().toLocaleDateString("en-US",{weekday:"long",month:"long",day:"numeric",year:"numeric"})}
          </div>
          <div style={{fontSize:isMobile?24:32,fontWeight:800,letterSpacing:-1}}>Good morning, <span style={{color:T.accent}}>{displayName}</span> 👋</div>
          <div style={{fontSize:14,color:T.sub,marginTop:4}}>Here's everything you need to win today.</div>
        </div>
        <div style={{background:T.grad,border:`1px solid ${T.accent}30`,borderRadius:18,padding:isMobile?16:22,marginBottom:16}}>
          <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:16}}>
            <div>
              <div style={{fontSize:11,color:T.sub,textTransform:"uppercase",letterSpacing:2,marginBottom:4}}>Monthly Pace</div>
              <div style={{fontSize:isMobile?32:40,fontWeight:800,lineHeight:1}}>{UNITS_SOLD} <span style={{fontSize:16,color:T.sub,fontWeight:400}}>/ {goalUnits} units</span></div>
            </div>
            <div style={{textAlign:"right"}}>
              <div style={{fontSize:11,color:T.sub,marginBottom:3}}>Gross MTD</div>
              <div style={{fontSize:isMobile?20:28,fontWeight:800,color:T.success}}>${(GROSS_MTD/1000).toFixed(1)}K</div>
              <div style={{fontSize:11,color:T.sub,marginTop:2}}>of ${(goalGross/1000).toFixed(0)}K goal</div>
            </div>
          </div>
          <div style={{background:T.muted,borderRadius:100,height:10,overflow:"hidden",marginBottom:8}}>
            <div style={{background:`linear-gradient(90deg,${T.accent},${T.amber})`,width:`${pace}%`,height:"100%",borderRadius:100}}/>
          </div>
          <div style={{display:"flex",justifyContent:"space-between"}}>
            <div style={{fontSize:12,color:T.sub}}>{pace}% complete</div>
            <div style={{fontSize:12,color:T.sub}}>{goalUnits-UNITS_SOLD} units remaining</div>
          </div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:16}}>
          {[
            {label:"Hot Leads",value:customers.filter(c=>c.status==="hot").length.toString(),color:T.danger},
            {label:"Appointments",value:upcoming.length.toString(),color:T.purple},
            {label:"Deals Delivered",value:UNITS_SOLD.toString(),color:T.success},
            {label:"Closing Ratio",value:`${CLOSING_RATIO}%`,color:T.blue},
          ].map(m=>(
            <div key={m.label} style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:isMobile?12:16}}>
              <div style={{fontSize:10,color:T.sub,textTransform:"uppercase",letterSpacing:1.5,marginBottom:6}}>{m.label}</div>
              <div style={{fontSize:isMobile?24:30,fontWeight:800,color:m.color}}>{m.value}</div>
            </div>
          ))}
        </div>
        <div style={{display:"grid",gridTemplateColumns:"repeat(3,1fr)",gap:10,marginBottom:16}}>
          {[
            {label:"Add Customer",icon:"＋",color:T.accent,fn:()=>{setAddMode(true);navTo("customers");}},
            {label:"Calculator",icon:"◈",color:T.blue,fn:()=>navTo("tools")},
            {label:"Coaching",icon:"◉",color:T.purple,fn:()=>navTo("ai")},
          ].map(a=>(
            <button key={a.label} onClick={a.fn} style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:"14px 8px",cursor:"pointer",textAlign:"center",fontFamily:"inherit"}}>
              <div style={{fontSize:22,color:a.color,marginBottom:6}}>{a.icon}</div>
              <div style={{fontSize:11,color:T.sub}}>{a.label}</div>
            </button>
          ))}
        </div>
        <Card>
          <SecTitle text="Daily Briefing"/>
          {briefLoad?<div style={{color:T.sub,fontSize:14,textAlign:"center",padding:16}}>✦ Generating your briefing...</div>:briefing?<div style={{fontSize:14,color:T.sub,lineHeight:1.9,whiteSpace:"pre-wrap"}}>{briefing}</div>:<div style={{color:T.muted,fontSize:14}}>Loading...</div>}
        </Card>
        {upcoming.length>0&&(
          <Card style={{border:`1px solid ${T.purple}30`}}>
            <SecTitle text="Upcoming Appointments" color={T.purple}/>
            {upcoming.map(c=>(
              <div key={c.id} onClick={()=>{setSelCust(c);navTo("customers");}} style={{padding:"10px 0",borderBottom:`1px solid ${T.border}`,cursor:"pointer"}}>
                <div style={{fontSize:14,fontWeight:700}}>{c.name}</div>
                <div style={{fontSize:12,color:T.purple,marginTop:2}}>📅 {formatDate(c.appointment)}</div>
                {c.apptNote&&<div style={{fontSize:12,color:T.sub,marginTop:1}}>{c.apptNote}</div>}
              </div>
            ))}
          </Card>
        )}
        <Card>
          <SecTitle text="Priority Follow-Ups" color={T.amber}/>
          {hot.length===0&&<div style={{fontSize:13,color:T.muted}}>No follow-ups right now.</div>}
          {hot.slice(0,5).map(c=>(
            <div key={c.id} onClick={()=>{setSelCust(c);navTo("customers");}} style={{display:"flex",alignItems:"center",justifyContent:"space-between",padding:"10px 0",borderBottom:`1px solid ${T.border}`,cursor:"pointer"}}>
              <div style={{flex:1,minWidth:0}}>
                <div style={{fontSize:14,fontWeight:700}}>{c.name}</div>
                <div style={{fontSize:12,color:T.sub,marginTop:1,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}}>{c.interest}</div>
              </div>
              <div style={{padding:"4px 10px",borderRadius:100,background:`${SC[c.status]}20`,color:SC[c.status],fontSize:11,fontWeight:700,flexShrink:0,marginLeft:8}}>{SE[c.status]}</div>
            </div>
          ))}
        </Card>
      </div>
    );
  };

  const renderCustomers=()=>{
    if(addMode)return(
      <div style={{maxWidth:700,margin:"0 auto",padding:pad}}>
        <button onClick={()=>setAddMode(false)} style={{background:"none",border:"none",color:T.accent,cursor:"pointer",fontSize:15,marginBottom:20,padding:0,fontFamily:"inherit"}}>← Back</button>
        <div style={{fontSize:isMobile?22:28,fontWeight:800,marginBottom:20}}>Add New Customer</div>
        <div style={{display:"grid",gridTemplateColumns:g(2),gap:14}}>
          {[
            {label:"Full Name *",key:"name",ph:"John Smith",type:"text"},
            {label:"Phone",key:"phone",ph:"416-555-0100",type:"tel"},
            {label:"Email",key:"email",ph:"john@email.com",type:"email"},
            {label:"Vehicle Interest",key:"interest",ph:"2024 Honda CR-V EX",type:"text"},
            {label:"Budget",key:"budget",ph:"$45,000",type:"text"},
            {label:"Trade-In Vehicle",key:"trade",ph:"2019 Toyota Camry",type:"text"},
          ].map(f=>(
            <div key={f.key}>
              <label style={lbl}>{f.label}</label>
              <input type={f.type} value={nc[f.key]} onChange={e=>setNc(p=>({...p,[f.key]:e.target.value}))} placeholder={f.ph} style={inp}/>
            </div>
          ))}
          <div>
            <label style={lbl}>Trade Value ($)</label>
            <input type="number" value={nc.tradeValue} onChange={e=>setNc(p=>({...p,tradeValue:parseFloat(e.target.value)||0}))} style={inp}/>
          </div>
          <div>
            <label style={lbl}>Lead Source</label>
            <select value={nc.source} onChange={e=>setNc(p=>({...p,source:e.target.value}))} style={{...inp,appearance:"none"}}>
              {["walk-in","internet","phone","referral","service drive","repeat customer"].map(s=><option key={s}>{s}</option>)}
            </select>
          </div>
        </div>
        <div style={{marginTop:14,marginBottom:20}}>
          <label style={lbl}>Notes</label>
          <textarea value={nc.notes} onChange={e=>setNc(p=>({...p,notes:e.target.value}))} placeholder="Key details..." rows={4} style={{...inp,resize:"none"}}/>
        </div>
        <button onClick={()=>{if(!nc.name)return;setCustomers(p=>[...p,{...nc,id:Date.now(),status:"fresh",lastContact:"Just now",visits:1,soldVehicle:"",appointment:null,apptNote:""}]);setNc({name:"",phone:"",email:"",interest:"",budget:"",source:"walk-in",notes:"",trade:"",tradeValue:0,contactPref:"phone"});setAddMode(false);}} style={{background:T.accent,border:"none",borderRadius:13,padding:"14px 40px",color:"#fff",cursor:"pointer",fontSize:16,fontWeight:800,fontFamily:"inherit"}}>Add Customer</button>
      </div>
    );

    if(editMode&&selCust)return(
      <div style={{maxWidth:700,margin:"0 auto",padding:pad}}>
        <button onClick={()=>setEditMode(false)} style={{background:"none",border:"none",color:T.accent,cursor:"pointer",fontSize:15,marginBottom:20,padding:0,fontFamily:"inherit"}}>← Back</button>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:20,flexWrap:"wrap",gap:10}}>
          <div style={{fontSize:isMobile?22:26,fontWeight:800}}>Edit Customer</div>
          <button onClick={()=>setShowDeleteConfirm(true)} style={{background:`${T.danger}15`,border:`1px solid ${T.danger}40`,borderRadius:10,padding:"8px 16px",color:T.danger,cursor:"pointer",fontSize:13,fontWeight:700,fontFamily:"inherit"}}>🗑 Delete</button>
        </div>
        {showDeleteConfirm&&(
          <div style={{background:`${T.danger}12`,border:`1px solid ${T.danger}40`,borderRadius:14,padding:18,marginBottom:20}}>
            <div style={{fontSize:15,fontWeight:700,color:T.danger,marginBottom:8}}>Delete {editData?.name}?</div>
            <div style={{display:"flex",gap:10}}>
              <button onClick={()=>deleteCust(selCust.id)} style={{background:T.danger,border:"none",borderRadius:10,padding:"10px 20px",color:"#fff",cursor:"pointer",fontSize:14,fontWeight:700,fontFamily:"inherit"}}>Yes, Delete</button>
              <button onClick={()=>setShowDeleteConfirm(false)} style={{background:"none",border:`1px solid ${T.border}`,borderRadius:10,padding:"10px 20px",color:T.sub,cursor:"pointer",fontSize:14,fontFamily:"inherit"}}>Cancel</button>
            </div>
          </div>
        )}
        <div style={{display:"grid",gridTemplateColumns:g(2),gap:14}}>
          {[
            {label:"Full Name",key:"name",type:"text"},
            {label:"Phone",key:"phone",type:"tel"},
            {label:"Email",key:"email",type:"email"},
            {label:"Vehicle Interest",key:"interest",type:"text"},
            {label:"Budget",key:"budget",type:"text"},
            {label:"Trade-In Vehicle",key:"trade",type:"text"},
          ].map(f=>(
            <div key={f.key}>
              <label style={lbl}>{f.label}</label>
              <input type={f.type} value={editData?.[f.key]||""} onChange={e=>setEditData(p=>({...p,[f.key]:e.target.value}))} style={inp}/>
            </div>
          ))}
          <div>
            <label style={lbl}>Trade Value ($)</label>
            <input type="number" value={editData?.tradeValue||0} onChange={e=>setEditData(p=>({...p,tradeValue:parseFloat(e.target.value)||0}))} style={inp}/>
          </div>
          <div>
            <label style={lbl}>Lead Source</label>
            <select value={editData?.source||"walk-in"} onChange={e=>setEditData(p=>({...p,source:e.target.value}))} style={{...inp,appearance:"none"}}>
              {["walk-in","internet","phone","referral","service drive","repeat customer"].map(s=><option key={s}>{s}</option>)}
            </select>
          </div>
        </div>
        <div style={{marginTop:14,marginBottom:20}}>
          <label style={lbl}>Notes</label>
          <textarea value={editData?.notes||""} onChange={e=>setEditData(p=>({...p,notes:e.target.value}))} rows={4} style={{...inp,resize:"none"}}/>
        </div>
        <div style={{display:"flex",gap:10}}>
          <button onClick={()=>{if(!editData?.name)return;updateCust(selCust.id,editData);setEditMode(false);}} style={{background:T.accent,border:"none",borderRadius:13,padding:"14px 32px",color:"#fff",cursor:"pointer",fontSize:15,fontWeight:800,fontFamily:"inherit"}}>Save Changes</button>
          <button onClick={()=>setEditMode(false)} style={{background:"none",border:`1px solid ${T.border}`,borderRadius:13,padding:"14px 20px",color:T.sub,cursor:"pointer",fontSize:15,fontFamily:"inherit"}}>Cancel</button>
        </div>
      </div>
    );

    if(selCust)return(
      <div style={{maxWidth:900,margin:"0 auto",padding:pad}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,flexWrap:"wrap",gap:10}}>
          <button onClick={()=>setSelCust(null)} style={{background:"none",border:"none",color:T.accent,cursor:"pointer",fontSize:15,padding:0,fontFamily:"inherit"}}>← Back</button>
          <div style={{display:"flex",gap:10}}>
            <button onClick={()=>{setEditData({...selCust});setEditMode(true);}} style={{background:`${T.blue}15`,border:`1px solid ${T.blue}40`,borderRadius:10,padding:"8px 14px",color:T.blue,cursor:"pointer",fontSize:13,fontWeight:700,fontFamily:"inherit"}}>✏️ Edit</button>
            <button onClick={()=>{setEditData({...selCust});setEditMode(true);setShowDeleteConfirm(true);}} style={{background:`${T.danger}12`,border:`1px solid ${T.danger}35`,borderRadius:10,padding:"8px 14px",color:T.danger,cursor:"pointer",fontSize:13,fontWeight:700,fontFamily:"inherit"}}>🗑</button>
          </div>
        </div>
        <div style={{marginBottom:16}}>
          <div style={{fontSize:isMobile?22:28,fontWeight:800}}>{selCust.name}</div>
          <div style={{display:"flex",gap:12,marginTop:6,flexWrap:"wrap",alignItems:"center"}}>
            <div style={{fontSize:13,color:T.sub}}>📞 {selCust.phone}</div>
            {selCust.email&&<div style={{fontSize:13,color:T.sub}}>✉️ {selCust.email}</div>}
            <div style={{padding:"4px 10px",borderRadius:100,background:`${SC[selCust.status]}18`,color:SC[selCust.status],fontSize:12,fontWeight:700}}>{SE[selCust.status]} {SL[selCust.status]}</div>
          </div>
        </div>
        {selCust.appointment&&isUpcoming(selCust.appointment)&&(
          <div style={{background:`${T.purple}15`,border:`1px solid ${T.purple}40`,borderRadius:12,padding:"12px 16px",marginBottom:14}}>
            <div style={{fontSize:11,color:T.purple,fontWeight:700,marginBottom:2}}>UPCOMING APPOINTMENT</div>
            <div style={{fontSize:15,fontWeight:700}}>📅 {formatDate(selCust.appointment)}</div>
            {selCust.apptNote&&<div style={{fontSize:12,color:T.sub,marginTop:2}}>{selCust.apptNote}</div>}
          </div>
        )}
        {selCust.status==="sold"&&selCust.soldVehicle&&(
          <div style={{background:`${T.success}12`,border:`1px solid ${T.success}30`,borderRadius:12,padding:"12px 16px",marginBottom:14}}>
            <div style={{fontSize:11,color:T.success,fontWeight:700,marginBottom:2}}>SOLD VEHICLE</div>
            <div style={{fontSize:14,fontWeight:700}}>✅ {selCust.soldVehicle}</div>
          </div>
        )}
        <Card>
          <SecTitle text="Customer Profile"/>
          {[
            {label:"Vehicle Interest",value:selCust.interest},
            {label:"Budget",value:selCust.budget},
            {label:"Source",value:selCust.source},
            {label:"Last Contact",value:selCust.lastContact},
            {label:"Visits",value:`${selCust.visits} visit${selCust.visits>1?"s":""}`},
            {label:"Trade-In",value:selCust.trade||"None"},
            {label:"Trade Value",value:selCust.tradeValue>0?fmt(selCust.tradeValue):"Not set"},
          ].map(d=>(
            <div key={d.label} style={{display:"flex",justifyContent:"space-between",padding:"9px 0",borderBottom:`1px solid ${T.border}`,gap:8}}>
              <div style={{fontSize:13,color:T.sub,flexShrink:0}}>{d.label}</div>
              <div style={{fontSize:13,fontWeight:600,textAlign:"right"}}>{d.value}</div>
            </div>
          ))}
        </Card>
        {selCust.notes&&<Card><SecTitle text="Notes"/><div style={{fontSize:14,color:T.sub,lineHeight:1.8}}>{selCust.notes}</div></Card>}
        <Card>
          <SecTitle text="Update Status" color={T.amber}/>
          <div style={{display:"flex",gap:8,flexWrap:"wrap",marginBottom:14}}>
            {Object.keys(SL).map(s=>(
              <button key={s} onClick={()=>{updateCust(selCust.id,{status:s});if(s==="sold")setShowSoldForm(true);}} style={{padding:"8px 12px",borderRadius:100,border:`1px solid ${selCust.status===s?SC[s]:T.border}`,background:selCust.status===s?`${SC[s]}18`:"transparent",color:selCust.status===s?SC[s]:T.sub,cursor:"pointer",fontSize:12,fontFamily:"inherit",fontWeight:selCust.status===s?700:400}}>
                {SE[s]} {SL[s]}
              </button>
            ))}
          </div>
          {(showSoldForm||selCust.status==="sold")&&(
            <div style={{background:T.surface,borderRadius:12,padding:12,border:`1px solid ${T.success}30`}}>
              <label style={{...lbl,color:T.success}}>Sold Vehicle Details</label>
              <input value={soldVehicleInput||selCust.soldVehicle} onChange={e=>setSoldVehicleInput(e.target.value)} placeholder="e.g. 2024 Honda CR-V EX-L · #H2401" style={inp}/>
              <button onClick={()=>{updateCust(selCust.id,{soldVehicle:soldVehicleInput});setShowSoldForm(false);}} style={{marginTop:10,background:T.success,border:"none",borderRadius:10,padding:"8px 20px",color:"#fff",cursor:"pointer",fontSize:13,fontWeight:700,fontFamily:"inherit"}}>Save</button>
            </div>
          )}
        </Card>
        <Card style={{border:`1px solid ${T.purple}25`}}>
          <SecTitle text="Book Appointment" color={T.purple}/>
          {!showAppt?(
            <button onClick={()=>setShowAppt(true)} style={{width:"100%",background:`${T.purple}15`,border:`1px solid ${T.purple}40`,borderRadius:12,padding:"12px",color:T.purple,cursor:"pointer",fontSize:14,fontWeight:700,fontFamily:"inherit"}}>📅 Schedule Appointment</button>
          ):(
            <div>
              <div style={{marginBottom:12}}><label style={lbl}>Date & Time</label><input type="datetime-local" value={apptDate} onChange={e=>setApptDate(e.target.value)} style={inp}/></div>
              <div style={{marginBottom:12}}><label style={lbl}>Note</label><input value={apptNote} onChange={e=>setApptNote(e.target.value)} placeholder="e.g. Test drive CR-V" style={inp}/></div>
              <div style={{display:"flex",gap:10}}>
                <button onClick={()=>{if(!apptDate)return;updateCust(selCust.id,{appointment:apptDate,apptNote});setShowAppt(false);setApptDate("");setApptNote("");}} style={{flex:1,background:T.purple,border:"none",borderRadius:10,padding:"12px",color:"#fff",cursor:"pointer",fontSize:14,fontWeight:700,fontFamily:"inherit"}}>Confirm</button>
                <button onClick={()=>setShowAppt(false)} style={{background:"none",border:`1px solid ${T.border}`,borderRadius:10,padding:"12px 16px",color:T.sub,cursor:"pointer",fontSize:14,fontFamily:"inherit"}}>Cancel</button>
              </div>
            </div>
          )}
        </Card>
        <Card style={{border:`1px solid ${T.blue}25`}}>
          <SecTitle text="AI Message Generator" color={T.blue}/>
          <div style={{display:"flex",gap:8,marginBottom:14,flexWrap:"wrap"}}>
            {["follow-up","test drive invite","delivery thank you","referral request"].map(t=>(
              <Pill key={t} label={t} active={custMsgType===t} onClick={()=>{setCustMsgType(t);setCustMsg("");}} color={T.blue}/>
            ))}
          </div>
          <AiBtn label={`Generate ${custMsgType}`} loading={custMsgLoad} color={T.blue} onClick={async()=>{
            setCustMsgLoad(true);setCustMsg("");
            const r=await callClaude(`Write a short natural ${custMsgType} message from Honda salesperson to ${selCust.name}. Interested in ${selCust.interest||"a Honda vehicle"}, budget ${selCust.budget||"not specified"}. Notes: ${selCust.notes||"none"}. Under 3 sentences. Warm and genuine. Sign off as ${displayName} from Honda.`);
            setCustMsg(r);setCustMsgLoad(false);
          }}/>
          {custMsg&&<RespBox text={custMsg} color={T.blue}/>}
        </Card>
      </div>
    );

    const filtered=customers.filter(c=>{
      const ms=c.name.toLowerCase().includes(cSearch.toLowerCase())||c.interest?.toLowerCase().includes(cSearch.toLowerCase());
      const mf=cFilter==="all"||c.status===cFilter;
      return ms&&mf;
    });

    return(
      <div style={{padding:pad}}>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:16,flexWrap:"wrap",gap:10}}>
          <div style={{fontSize:isMobile?22:28,fontWeight:800}}>Customers <span style={{fontSize:14,color:T.sub,fontWeight:400}}>({filtered.length})</span></div>
          <button onClick={()=>setAddMode(true)} style={{background:T.accent,border:"none",borderRadius:100,padding:"10px 20px",color:"#fff",cursor:"pointer",fontSize:14,fontWeight:700,fontFamily:"inherit"}}>＋ Add</button>
        </div>
        <div style={{marginBottom:14}}>
          <input value={cSearch} onChange={e=>setCSearch(e.target.value)} placeholder="Search by name or vehicle..." style={{...inp,marginBottom:10}}/>
          <div style={{display:"flex",gap:8,flexWrap:"wrap"}}>
            {["all","hot","follow-up","fresh","sold","lost"].map(s=>(
              <Pill key={s} label={s==="all"?"All":`${SE[s]||""} ${SL[s]||""}`} active={cFilter===s} onClick={()=>setCFilter(s)} color={SC[s]||T.accent}/>
            ))}
          </div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":g(3),gap:12}}>
          {filtered.map(c=>(
            <div key={c.id} onClick={()=>setSelCust(c)} style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:16,padding:16,cursor:"pointer"}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"flex-start",marginBottom:8}}>
                <div>
                  <div style={{fontSize:15,fontWeight:700}}>{c.name}</div>
                  <div style={{fontSize:12,color:T.sub,marginTop:2}}>📞 {c.phone}</div>
                </div>
                <div style={{padding:"4px 10px",borderRadius:100,background:`${SC[c.status]}18`,color:SC[c.status],fontSize:11,fontWeight:700,flexShrink:0}}>{SE[c.status]}</div>
              </div>
              <div style={{fontSize:13,color:T.sub}}>{c.interest}</div>
              {c.trade&&<div style={{fontSize:12,color:T.amber,marginTop:4}}>🚗 {c.trade}</div>}
              {c.soldVehicle&&<div style={{fontSize:12,color:T.success,marginTop:4}}>✅ {c.soldVehicle}</div>}
              {c.appointment&&isUpcoming(c.appointment)&&<div style={{fontSize:12,color:T.purple,marginTop:6,background:`${T.purple}10`,padding:"4px 8px",borderRadius:6}}>📅 {formatDate(c.appointment)}</div>}
              <div style={{display:"flex",justifyContent:"space-between",marginTop:8}}>
                <div style={{fontSize:11,color:T.muted}}>{c.source}</div>
                <div style={{fontSize:11,color:T.muted}}>{c.lastContact}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderDeals=()=>(
    <div style={{padding:pad}}>
      <div style={{fontSize:isMobile?22:28,fontWeight:800,marginBottom:14}}>Deals & Pipeline</div>
      <div style={{display:"flex",gap:8,marginBottom:18,flexWrap:"wrap"}}>
        {[["pipeline","Pipeline"],["trade","Trade-Ins"],["delivery","Delivery"]].map(([id,lb])=>(
          <Pill key={id} label={lb} active={dealTab===id} onClick={()=>setDealTab(id)}/>
        ))}
      </div>
      {dealTab==="pipeline"&&<>
        <div style={{display:"grid",gridTemplateColumns:"1fr 1fr",gap:12,marginBottom:16}}>
          {[
            {label:"Delivered",value:deals.filter(d=>d.status==="delivered").length.toString(),color:T.success},
            {label:"Pending",value:deals.filter(d=>d.status==="pending").length.toString(),color:T.amber},
            {label:"Gross MTD",value:`$${(GROSS_MTD/1000).toFixed(1)}K`,color:T.accent},
            {label:"Avg Gross",value:UNITS_SOLD>0?`$${Math.round(GROSS_MTD/UNITS_SOLD).toLocaleString()}`:"—",color:T.blue},
          ].map(m=>(
            <div key={m.label} style={{background:T.grad,border:`1px solid ${T.accent}30`,borderRadius:14,padding:14,textAlign:"center"}}>
              <div style={{fontSize:isMobile?22:28,fontWeight:800,color:m.color}}>{m.value}</div>
              <div style={{fontSize:11,color:T.sub,textTransform:"uppercase",letterSpacing:1,marginTop:4}}>{m.label}</div>
            </div>
          ))}
        </div>
        {showNewDeal?(
          <Card style={{border:`1px solid ${T.accent}30`,marginBottom:16}}>
            <SecTitle text="Log New Deal"/>
            <div style={{display:"grid",gridTemplateColumns:g(2),gap:12}}>
              {[
                {label:"Customer Name *",key:"customer",ph:"John Smith"},
                {label:"Vehicle *",key:"vehicle",ph:"2024 Honda CR-V EX"},
                {label:"Stock #",key:"stock",ph:"H2401"},
                {label:"Front Gross ($)",key:"front",ph:"2000",type:"number"},
                {label:"Back Gross ($)",key:"back",ph:"1200",type:"number"},
              ].map(f=>(
                <div key={f.key}>
                  <label style={lbl}>{f.label}</label>
                  <input type={f.type||"text"} value={newDeal[f.key]} onChange={e=>setNewDeal(p=>({...p,[f.key]:e.target.value}))} placeholder={f.ph} style={inp}/>
                </div>
              ))}
              <div>
                <label style={lbl}>Type</label>
                <select value={newDeal.type} onChange={e=>setNewDeal(p=>({...p,type:e.target.value}))} style={{...inp,appearance:"none"}}>
                  <option value="finance">Finance</option>
                  <option value="lease">Lease</option>
                </select>
              </div>
            </div>
            <div style={{display:"flex",gap:10,marginTop:14}}>
              <button onClick={addDeal} style={{background:T.success,border:"none",borderRadius:12,padding:"12px 24px",color:"#fff",cursor:"pointer",fontSize:14,fontWeight:700,fontFamily:"inherit"}}>✅ Save Deal</button>
              <button onClick={()=>setShowNewDeal(false)} style={{background:"none",border:`1px solid ${T.border}`,borderRadius:12,padding:"12px 16px",color:T.sub,cursor:"pointer",fontSize:14,fontFamily:"inherit"}}>Cancel</button>
            </div>
          </Card>
        ):(
          <button onClick={()=>setShowNewDeal(true)} style={{width:"100%",background:`${T.accent}10`,border:`1px dashed ${T.accent}60`,borderRadius:14,padding:14,color:T.accent,cursor:"pointer",fontSize:14,fontWeight:700,fontFamily:"inherit",marginBottom:14}}>＋ Log New Deal</button>
        )}
        <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":g(2),gap:12}}>
          {deals.map(d=>(
            <div key={d.id} style={{background:T.card,border:`1px solid ${d.status==="pending"?T.amber+"45":T.border}`,borderRadius:14,padding:16}}>
              <div style={{display:"flex",justifyContent:"space-between",marginBottom:8,flexWrap:"wrap",gap:6}}>
                <div style={{fontSize:15,fontWeight:700}}>{d.customer}</div>
                <div style={{fontSize:12,padding:"4px 10px",borderRadius:100,background:d.status==="delivered"?`${T.success}18`:`${T.amber}18`,color:d.status==="delivered"?T.success:T.amber,fontWeight:700}}>{d.status==="delivered"?"✅ Delivered":"⏳ Pending"}</div>
              </div>
              <div style={{fontSize:13,color:T.sub,marginBottom:3}}>{d.vehicle}</div>
              <div style={{fontSize:12,color:T.muted,marginBottom:10}}>{d.type?.toUpperCase()} · #{d.stock} · {d.date}</div>
              <div style={{display:"flex",gap:12,flexWrap:"wrap"}}>
                <div style={{fontSize:13}}><span style={{color:T.sub}}>Front </span><span style={{fontWeight:700}}>${(d.front||0).toLocaleString()}</span></div>
                <div style={{fontSize:13}}><span style={{color:T.sub}}>Back </span><span style={{fontWeight:700}}>${(d.back||0).toLocaleString()}</span></div>
                <div style={{fontSize:13}}><span style={{color:T.sub}}>Total </span><span style={{fontWeight:700,color:T.success}}>${(d.total||0).toLocaleString()}</span></div>
              </div>
            </div>
          ))}
        </div>
      </>}
      {dealTab==="trade"&&<>
        <Card style={{border:`1px solid ${T.blue}25`}}>
          <SecTitle text="75/25 Commission Split" color={T.blue}/>
          <div style={{fontSize:14,color:T.sub,lineHeight:1.8}}>For every trade-in you source: <span style={{color:T.amber,fontWeight:700}}>75%</span> of the trade profit goes to you, <span style={{color:T.text,fontWeight:600}}>25%</span> to the house.</div>
        </Card>
        <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":g(2),gap:12}}>
          {customers.filter(c=>c.trade).map(c=>(
            <div key={c.id} style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:16}}>
              <div style={{fontSize:15,fontWeight:700,marginBottom:6}}>{c.name}</div>
              <div style={{fontSize:14,color:T.amber,marginBottom:4}}>🚗 {c.trade}</div>
              {c.tradeValue>0&&<div style={{fontSize:13,color:T.success,fontWeight:600}}>Est. Value: {fmt(c.tradeValue)}</div>}
            </div>
          ))}
        </div>
      </>}
      {dealTab==="delivery"&&<>
        <div style={{background:`${T.success}12`,border:`1px solid ${T.success}25`,borderRadius:12,padding:12,marginBottom:14,fontSize:13,color:T.success}}>📋 Delivery Checklist — click items to complete</div>
        <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":g(2),gap:10}}>
          {DELIVERY_ITEMS.map((item,i)=>(
            <div key={i} onClick={()=>setDelivery(p=>{const n=[...p];n[i]=!n[i];return n;})} style={{display:"flex",alignItems:"center",gap:12,padding:"12px 14px",background:T.card,border:`1px solid ${delivery[i]?T.success+"40":T.border}`,borderRadius:12,cursor:"pointer"}}>
              <div style={{width:22,height:22,borderRadius:6,border:`2px solid ${delivery[i]?T.success:T.border}`,background:delivery[i]?`${T.success}18`:"transparent",display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,color:T.success,fontSize:13,fontWeight:700}}>{delivery[i]?"✓":""}</div>
              <div style={{fontSize:13,color:delivery[i]?T.muted:T.text,textDecoration:delivery[i]?"line-through":"none"}}>{item}</div>
            </div>
          ))}
        </div>
        <div style={{marginTop:14,fontSize:13,color:delivery.filter(Boolean).length===DELIVERY_ITEMS.length?T.success:T.sub}}>
          {delivery.filter(Boolean).length} / {DELIVERY_ITEMS.length} {delivery.filter(Boolean).length===DELIVERY_ITEMS.length&&"🎉 Ready!"}
        </div>
      </>}
    </div>
  );

  const renderTools=()=>(
    <div style={{padding:pad}}>
      <div style={{fontSize:isMobile?22:28,fontWeight:800,marginBottom:14}}>Tools</div>
      <div style={{display:"flex",gap:8,marginBottom:18,flexWrap:"wrap"}}>
        {[["calculator","◈ Calculator"],["inventory","🚗 Inventory"],["lease","📋 Leases"],["service","🔧 Service"]].map(([id,lb])=>(
          <Pill key={id} label={lb} active={toolTab===id} onClick={()=>setToolTab(id)} color={T.blue}/>
        ))}
      </div>
      {toolTab==="calculator"&&<>
        <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"1fr 1fr",gap:24,maxWidth:1000}}>
          <div>
            <div style={{display:"flex",gap:10,marginBottom:18}}>
              <Pill label="Finance" active={calcMode==="finance"} onClick={()=>setCalcMode("finance")}/>
              <Pill label="Lease" active={calcMode==="lease"} onClick={()=>setCalcMode("lease")}/>
            </div>
            <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:14,marginBottom:14,display:"flex",justifyContent:"space-between",alignItems:"center"}}>
              <div>
                <div style={{fontSize:14,fontWeight:600}}>Include HST (13%)</div>
                <div style={{fontSize:12,color:T.sub,marginTop:2}}>Ontario — adds {fmt(hstAmount)}</div>
              </div>
              <Toggle checked={cv.includeHST} onChange={v=>setCv(p=>({...p,includeHST:v}))}/>
            </div>
            {[
              {label:"Vehicle Price (before tax)",key:"price",min:10000,max:150000,step:500,fmt:v=>fmt(v)},
              {label:"Down Payment",key:"down",min:0,max:50000,step:500,fmt:v=>fmt(v)},
              {label:"Trade-In Value",key:"tradeValue",min:0,max:60000,step:500,fmt:v=>fmt(v)},
              {label:"Interest Rate",key:"rate",min:0,max:25,step:0.1,fmt:v=>`${v}%`},
              {label:"Term (months)",key:"term",min:24,max:96,step:12,fmt:v=>`${v} mo`},
              ...(calcMode==="lease"?[{label:"Residual Value",key:"residual",min:25,max:75,step:1,fmt:v=>`${v}%`}]:[]),
            ].map(f=>(
              <div key={f.key} style={{marginBottom:16}}>
                <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
                  <label style={{...lbl,marginBottom:0,fontSize:11}}>{f.label}</label>
                  <div style={{fontSize:13,fontWeight:700,color:f.key==="tradeValue"?T.success:T.accent}}>{f.fmt(cv[f.key])}</div>
                </div>
                <input type="range" min={f.min} max={f.max} step={f.step} value={cv[f.key]} onChange={e=>setCv(p=>({...p,[f.key]:parseFloat(e.target.value)}))} style={{width:"100%",accentColor:f.key==="tradeValue"?T.success:T.accent}}/>
              </div>
            ))}
          </div>
          <div style={{display:"flex",flexDirection:"column",gap:14}}>
            <div style={{background:T.grad,border:`1px solid ${T.accent}35`,borderRadius:20,padding:isMobile?24:36,textAlign:"center"}}>
              <div style={{fontSize:12,color:T.sub,textTransform:"uppercase",letterSpacing:2,marginBottom:10}}>{calcMode==="finance"?"Monthly Finance":"Monthly Lease"}</div>
              <div style={{fontSize:isMobile?56:72,fontWeight:800,color:T.accent,lineHeight:1}}>${calcMode==="finance"?fp():lp()}</div>
              <div style={{fontSize:13,color:T.sub,marginTop:10}}>{cv.term} mo · {cv.rate}% APR</div>
            </div>
            <Card>
              <SecTitle text="Price Breakdown"/>
              {[
                {label:"Before HST",value:fmt(cv.price),color:T.text},
                {label:"HST (13%)",value:cv.includeHST?`+ ${fmt(hstAmount)}`:"Not included",color:cv.includeHST?T.danger:T.muted},
                {label:"After HST",value:fmt(cv.includeHST?cv.price*(1+HST_RATE):cv.price),color:T.text},
                {label:"Trade-In",value:cv.tradeValue>0?`- ${fmt(cv.tradeValue)}`:"None",color:cv.tradeValue>0?T.success:T.muted},
                ...(cv.tradeValue>0&&cv.includeHST?[{label:"HST Saving on Trade",value:`- ${fmt(tradeHSTSaving)}`,color:T.success}]:[]),
                {label:"Down Payment",value:`- ${fmt(cv.down)}`,color:T.amber},
                {label:"Amount Financed",value:fmt(Math.max(netPrice-cv.down,0)),color:T.accent,bold:true},
              ].map(r=>(
                <div key={r.label} style={{display:"flex",justifyContent:"space-between",padding:"8px 0",borderBottom:`1px solid ${T.border}`}}>
                  <div style={{fontSize:13,color:T.sub}}>{r.label}</div>
                  <div style={{fontSize:13,fontWeight:r.bold?800:600,color:r.color}}>{r.value}</div>
                </div>
              ))}
            </Card>
          </div>
        </div>
      </>}
      {toolTab==="inventory"&&<>
        <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14,flexWrap:"wrap",gap:10}}>
          <input value={invSearch} onChange={e=>setInvSearch(e.target.value)} placeholder="Search model, trim, stock..." style={{...inp,flex:1,minWidth:180}}/>
          <div style={{display:"flex",gap:10,alignItems:"center"}}>
            <div style={{fontSize:13,color:T.sub}}>{inventory.length} vehicles</div>
            <button onClick={()=>setShowAddInv(true)} style={{background:T.accent,border:"none",borderRadius:10,padding:"10px 16px",color:"#fff",cursor:"pointer",fontSize:13,fontWeight:700,fontFamily:"inherit"}}>＋ Add</button>
          </div>
        </div>
        {showAddInv&&(
          <Card style={{border:`1px solid ${T.accent}30`,marginBottom:14}}>
            <SecTitle text="Add New Vehicle"/>
            <div style={{display:"grid",gridTemplateColumns:g(2),gap:12}}>
              {[
                {label:"Year",key:"year",type:"number",ph:"2024"},
                {label:"Make",key:"make",ph:"Honda"},
                {label:"Model *",key:"model",ph:"CR-V"},
                {label:"Trim",key:"trim",ph:"EX-L AWD"},
                {label:"Color",key:"color",ph:"Sonic Grey Pearl"},
                {label:"Stock # *",key:"stock",ph:"H2401"},
                {label:"Price ($)",key:"price",type:"number",ph:"44990"},
                {label:"Mileage (km)",key:"mileage",type:"number",ph:"0"},
                {label:"Days on Lot",key:"days",type:"number",ph:"1"},
              ].map(f=>(
                <div key={f.key}>
                  <label style={lbl}>{f.label}</label>
                  <input type={f.type||"text"} value={newInv[f.key]} onChange={e=>setNewInv(p=>({...p,[f.key]:e.target.value}))} placeholder={f.ph} style={inp}/>
                </div>
              ))}
              <div>
                <label style={lbl}>Type</label>
                <select value={newInv.type} onChange={e=>setNewInv(p=>({...p,type:e.target.value}))} style={{...inp,appearance:"none"}}>
                  <option value="new">New</option>
                  <option value="used">Used</option>
                </select>
              </div>
            </div>
            <div style={{display:"flex",gap:10,marginTop:14}}>
              <button onClick={addInventory} style={{background:T.success,border:"none",borderRadius:12,padding:"12px 24px",color:"#fff",cursor:"pointer",fontSize:14,fontWeight:700,fontFamily:"inherit"}}>✅ Add to Lot</button>
              <button onClick={()=>setShowAddInv(false)} style={{background:"none",border:`1px solid ${T.border}`,borderRadius:12,padding:"12px 16px",color:T.sub,cursor:"pointer",fontSize:14,fontFamily:"inherit"}}>Cancel</button>
            </div>
          </Card>
        )}
        <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":g(3),gap:12}}>
          {inventory.filter(v=>invSearch===""||`${v.year} ${v.make} ${v.model} ${v.trim} ${v.color} ${v.stock}`.toLowerCase().includes(invSearch.toLowerCase())).map(v=>(
            editInv===v.id?(
              <Card key={v.id} style={{border:`1px solid ${T.blue}40`}}>
                <div style={{fontSize:14,fontWeight:700,marginBottom:12,color:T.blue}}>Edit Vehicle</div>
                {[
                  {label:"Price ($)",key:"price",type:"number"},
                  {label:"Color",key:"color",type:"text"},
                  {label:"Trim",key:"trim",type:"text"},
                  {label:"Days on Lot",key:"days",type:"number"},
                ].map(f=>(
                  <div key={f.key} style={{marginBottom:10}}>
                    <label style={lbl}>{f.label}</label>
                    <input type={f.type} defaultValue={v[f.key]} onChange={e=>{const val=f.type==="number"?parseInt(e.target.value)||0:e.target.value;updateInventory(v.id,{[f.key]:val});}} style={inp}/>
                  </div>
                ))}
                <button onClick={()=>setEditInv(null)} style={{background:T.success,border:"none",borderRadius:10,padding:"10px 20px",color:"#fff",cursor:"pointer",fontSize:13,fontWeight:700,fontFamily:"inherit"}}>Done</button>
              </Card>
            ):(
              <div key={v.id} style={{background:T.card,border:`1px solid ${v.days>25?T.danger+"45":T.border}`,borderRadius:14,padding:16}}>
                <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
                  <div style={{fontSize:14,fontWeight:700}}>{v.year} {v.model}</div>
                  <div style={{fontSize:11,padding:"3px 8px",borderRadius:100,background:v.type==="new"?`${T.blue}18`:`${T.amber}18`,color:v.type==="new"?T.blue:T.amber,fontWeight:700}}>{v.type==="new"?"NEW":"USED"}</div>
                </div>
                <div style={{fontSize:12,color:T.sub,marginBottom:10}}>{v.trim} · {v.color}</div>
                <div style={{display:"flex",justifyContent:"space-between",marginBottom:3}}>
                  <div style={{fontSize:12,color:T.sub}}>Before HST</div>
                  <div style={{fontSize:15,fontWeight:800}}>{fmt(v.price)}</div>
                </div>
                <div style={{display:"flex",justifyContent:"space-between",marginBottom:10}}>
                  <div style={{fontSize:12,color:T.sub}}>After HST</div>
                  <div style={{fontSize:13,fontWeight:700,color:T.accent}}>{fmt(v.price*(1+HST_RATE))}</div>
                </div>
                <div style={{display:"flex",justifyContent:"space-between",marginBottom:12}}>
                  <div style={{fontSize:11,color:v.days>25?T.danger:T.muted}}>{v.days} days{v.days>25?" ⚠️":""}</div>
                  <div style={{fontSize:11,color:T.muted}}>#{v.stock}</div>
                </div>
                <div style={{display:"flex",gap:8}}>
                  <button onClick={()=>setEditInv(v.id)} style={{flex:1,background:`${T.blue}15`,border:`1px solid ${T.blue}30`,borderRadius:8,padding:"8px",color:T.blue,cursor:"pointer",fontSize:12,fontWeight:700,fontFamily:"inherit"}}>✏️ Edit</button>
                  <button onClick={()=>removeInventory(v.id)} style={{flex:1,background:`${T.danger}15`,border:`1px solid ${T.danger}30`,borderRadius:8,padding:"8px",color:T.danger,cursor:"pointer",fontSize:12,fontWeight:700,fontFamily:"inherit"}}>🗑 Remove</button>
                </div>
              </div>
            )
          ))}
        </div>
      </>}
      {toolTab==="lease"&&<>
        <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":g(2),gap:14}}>
          {LEASES.map(l=>(
            <div key={l.id} style={{background:T.card,border:`1px solid ${l.urgency==="high"?T.danger+"45":l.urgency==="medium"?T.amber+"30":T.border}`,borderRadius:14,padding:16}}>
              <div style={{display:"flex",justifyContent:"space-between",marginBottom:8,flexWrap:"wrap",gap:6}}>
                <div>
                  <div style={{fontSize:15,fontWeight:700}}>{l.customer}</div>
                  <div style={{fontSize:12,color:T.sub}}>{l.phone}</div>
                </div>
                <div style={{textAlign:"right"}}>
                  <div style={{fontSize:12,color:l.urgency==="high"?T.danger:T.amber,fontWeight:700}}>⏰ {l.maturity}</div>
                  <div style={{fontSize:11,color:T.muted}}>${l.payment}/mo</div>
                </div>
              </div>
              <div style={{fontSize:13,color:T.sub,marginBottom:8}}>{l.vehicle}</div>
              <div style={{fontSize:14,color:l.equity.startsWith("+")?T.success:T.danger,fontWeight:700,marginBottom:12}}>Equity: {l.equity}</div>
              <AiBtn label="Generate Call Script" loading={lsLoad&&lsId===l.id} color={T.purple} onClick={async()=>{
                setLsId(l.id);setLsLoad(true);setLsText("");
                const r=await callClaude(`Write a natural warm phone script for Honda salesperson ${displayName} calling ${l.customer}. Their ${l.vehicle} lease matures in ${l.maturity}. Equity: ${l.equity}. Payment: $${l.payment}/mo. Goal: book appointment. Max 5 sentences. Genuine not pushy.`);
                setLsText(r);setLsLoad(false);
              }}/>
              {lsId===l.id&&lsText&&<RespBox text={lsText} color={T.purple}/>}
            </div>
          ))}
        </div>
      </>}
      {toolTab==="service"&&<>
        <div style={{background:`${T.amber}12`,border:`1px solid ${T.amber}30`,borderRadius:12,padding:14,marginBottom:14}}>
          <div style={{fontSize:14,color:T.amber,fontWeight:600,marginBottom:4}}>⚡ {SERVICE.length} customers in the service bay</div>
          <div style={{fontSize:13,color:T.sub}}>Approach them while they wait.</div>
        </div>
        <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":g(2),gap:14}}>
          {SERVICE.map(s=>(
            <div key={s.id} style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:14,padding:16}}>
              <div style={{display:"flex",justifyContent:"space-between",marginBottom:8}}>
                <div>
                  <div style={{fontSize:15,fontWeight:700}}>{s.customer}</div>
                  <div style={{fontSize:12,color:T.sub}}>{s.vehicle}</div>
                </div>
                <div style={{fontSize:15,fontWeight:800,color:T.success}}>{s.equity}</div>
              </div>
              <div style={{fontSize:12,color:T.muted,marginBottom:12,padding:"6px 10px",background:T.surface,borderRadius:8}}>{s.service} · Bill: {s.bill}</div>
              <div style={{background:`${T.amber}10`,borderRadius:10,padding:12,fontSize:13,color:T.text,lineHeight:1.7,border:`1px solid ${T.amber}20`}}>
                💬 <span style={{color:T.amber,fontWeight:600}}>Suggested: </span>"Hi {s.customer.split(" ")[0]}, while your vehicle is being taken care of — I noticed something that could save you money on your monthly payment. Do you have two minutes?"
              </div>
            </div>
          ))}
        </div>
      </>}
    </div>
  );

  const renderAI=()=>(
    <div style={{padding:pad}}>
      <div style={{fontSize:isMobile?22:28,fontWeight:800,marginBottom:14}}>Coaching</div>
      <div style={{display:"flex",gap:8,marginBottom:18,flexWrap:"wrap"}}>
        {[["coach","🥊 Objections"],["training","📖 Training"],["chat","💬 AI Chat"],["goals","🎯 Goals"],["insights","📊 Insights"]].map(([id,lb])=>(
          <Pill key={id} label={lb} active={aiTab===id} onClick={()=>setAiTab(id)} color={T.purple}/>
        ))}
      </div>
      {aiTab==="coach"&&<>
        <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"1fr 1fr",gap:20,maxWidth:1000}}>
          <Card style={{border:`1px solid ${T.purple}25`}}>
            <SecTitle text="Objection Handler" color={T.purple}/>
            <textarea value={obj} onChange={e=>setObj(e.target.value)} placeholder={`"The payment is too high"\n"I want to think about it"`} rows={4} style={{...inp,resize:"none",marginBottom:14}}/>
            <AiBtn label="Get Response Strategy" loading={coachLoad} onClick={async()=>{
              if(!obj.trim())return;
              setCoachLoad(true);setCoachResp("");
              const r=await callClaude(`You are an expert automotive sales coach. Salesperson faces: "${obj}". Give a 3-part response: 1) Acknowledge 1 sentence, 2) Reframe 2-3 sentences, 3) Advance 1 sentence. Conversational, real.`);
              setCoachResp(r);setCoachLoad(false);
            }}/>
            {coachResp&&<RespBox text={coachResp}/>}
          </Card>
          <Card>
            <SecTitle text="Common Objections"/>
            {OBJECTIONS.map(o=>(
              <button key={o} onClick={()=>setObj(o)} style={{display:"block",width:"100%",background:"none",border:`1px solid ${T.border}`,borderRadius:10,padding:"10px 14px",color:T.sub,cursor:"pointer",fontSize:13,textAlign:"left",marginBottom:8,fontFamily:"inherit"}}>"{o}"</button>
            ))}
          </Card>
        </div>
      </>}
      {aiTab==="training"&&<>
        <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":selStep?"1fr 1fr":"1fr",gap:20,maxWidth:1000}}>
          <div>
            <div style={{fontSize:13,color:T.sub,marginBottom:12}}>Click any step for a detailed AI coaching guide.</div>
            {STEPS.map(s=>(
              <div key={s.n} onClick={()=>loadStepDetail(s)} style={{background:selStep?.n===s.n?`${T.blue}15`:T.card,border:`1px solid ${selStep?.n===s.n?T.blue:T.border}`,borderRadius:14,padding:14,marginBottom:10,display:"flex",gap:14,cursor:"pointer"}}>
                <div style={{width:36,height:36,borderRadius:10,background:`${T.blue}18`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:14,fontWeight:800,color:T.blue,flexShrink:0}}>{s.n}</div>
                <div style={{flex:1}}>
                  <div style={{fontSize:14,fontWeight:700,color:selStep?.n===s.n?T.blue:T.text}}>{s.t}</div>
                  <div style={{fontSize:12,color:T.sub,marginTop:3,lineHeight:1.5}}>{s.d}</div>
                </div>
                <div style={{fontSize:16,color:selStep?.n===s.n?T.blue:T.muted,alignSelf:"center"}}>→</div>
              </div>
            ))}
          </div>
          {selStep&&(
            <Card style={{border:`1px solid ${T.blue}30`}}>
              <div style={{display:"flex",justifyContent:"space-between",alignItems:"center",marginBottom:14}}>
                <SecTitle text={`Step ${selStep.n}: ${selStep.t}`} color={T.blue}/>
                <button onClick={()=>setSelStep(null)} style={{background:"none",border:"none",color:T.muted,cursor:"pointer",fontSize:18}}>✕</button>
              </div>
              {stepLoad?<div style={{color:T.sub,fontSize:14,textAlign:"center",padding:20}}>✦ Loading...</div>:<div style={{fontSize:14,color:T.sub,lineHeight:1.85,whiteSpace:"pre-wrap"}}>{stepDetail}</div>}
            </Card>
          )}
        </div>
      </>}
      {aiTab==="chat"&&<>
        <div style={{maxWidth:800}}>
          <div style={{background:T.card,border:`1px solid ${T.border}`,borderRadius:16,padding:16,marginBottom:14,height:isMobile?340:420,overflowY:"auto",display:"flex",flexDirection:"column",gap:10}}>
            {chatMessages.map((m,i)=>(
              <div key={i} style={{display:"flex",justifyContent:m.role==="user"?"flex-end":"flex-start"}}>
                <div style={{maxWidth:"80%",background:m.role==="user"?`${T.accent}20`:T.surface,border:`1px solid ${m.role==="user"?T.accent+"40":T.border}`,borderRadius:14,padding:"10px 14px",fontSize:14,color:T.text,lineHeight:1.7}}>
                  {m.role==="ai"&&<div style={{fontSize:10,color:T.accent,fontWeight:700,marginBottom:4,textTransform:"uppercase",letterSpacing:1}}>✦ DriveMind AI</div>}
                  {m.text}
                </div>
              </div>
            ))}
            {chatLoad&&<div style={{display:"flex",justifyContent:"flex-start"}}><div style={{background:T.surface,border:`1px solid ${T.border}`,borderRadius:14,padding:"10px 14px",fontSize:14,color:T.sub}}>✦ Thinking...</div></div>}
          </div>
          <div style={{display:"flex",gap:10}}>
            <input value={chatInput} onChange={e=>setChatInput(e.target.value)} onKeyDown={e=>e.key==="Enter"&&sendChat()} placeholder="Ask anything about sales, customers, deals..." style={{...inp,flex:1}}/>
            <button onClick={sendChat} style={{background:T.purple,border:"none",borderRadius:12,padding:"10px 20px",color:"#fff",cursor:"pointer",fontSize:14,fontWeight:700,fontFamily:"inherit"}}>Send</button>
          </div>
        </div>
      </>}
      {aiTab==="goals"&&<>
        <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"1fr 1fr",gap:20,maxWidth:900}}>
          <div>
            <Card>
              <SecTitle text="Monthly Targets" color={T.amber}/>
              <div style={{marginBottom:14}}><label style={lbl}>Unit Target</label><input type="number" value={goalUnits} onChange={e=>setGoalUnits(parseInt(e.target.value)||0)} style={inp}/></div>
              <div><label style={lbl}>Gross Target ($)</label><input type="number" value={goalGross} onChange={e=>setGoalGross(parseInt(e.target.value)||0)} style={inp}/></div>
            </Card>
            <Card>
              <SecTitle text="Activity Tracker" color={T.blue}/>
              {[
                {label:"Customers in Pipeline",v:customers.length,t:20},
                {label:"Hot Leads",v:customers.filter(c=>c.status==="hot").length,t:5},
                {label:"Deals Delivered",v:UNITS_SOLD,t:goalUnits},
                {label:"Deals Pending",v:deals.filter(d=>d.status==="pending").length,t:3},
              ].map(a=>(
                <div key={a.label} style={{display:"flex",justifyContent:"space-between",alignItems:"center",padding:"10px 0",borderBottom:`1px solid ${T.border}`}}>
                  <div style={{fontSize:13}}>{a.label}</div>
                  <div style={{display:"flex",alignItems:"center",gap:6}}>
                    <div style={{fontSize:18,fontWeight:800,color:a.v>=a.t?T.success:T.text}}>{a.v}</div>
                    <div style={{fontSize:12,color:T.muted}}>/ {a.t}</div>
                  </div>
                </div>
              ))}
            </Card>
          </div>
          <Card style={{background:T.grad,border:`1px solid ${T.accent}30`}}>
            <SecTitle text="Monthly Progress"/>
            {[
              {label:"Units",current:UNITS_SOLD,target:goalUnits,color:T.accent,fmt:(c,t)=>`${c} / ${t}`},
              {label:"Gross",current:GROSS_MTD,target:goalGross,color:T.success,fmt:(c,t)=>`$${c.toLocaleString()} / $${t.toLocaleString()}`},
            ].map(g=>{
              const pct=Math.min(Math.round((g.current/g.target)*100),100);
              return(
                <div key={g.label} style={{marginBottom:20}}>
                  <div style={{display:"flex",justifyContent:"space-between",marginBottom:6}}>
                    <div style={{fontSize:14,fontWeight:600}}>{g.label}</div>
                    <div style={{fontSize:14,color:g.color,fontWeight:700}}>{g.fmt(g.current,g.target)}</div>
                  </div>
                  <div style={{background:T.muted,borderRadius:100,height:10,marginBottom:4}}>
                    <div style={{background:g.color,width:`${pct}%`,height:"100%",borderRadius:100}}/>
                  </div>
                  <div style={{fontSize:12,color:T.muted}}>{pct}% of target</div>
                </div>
              );
            })}
          </Card>
        </div>
      </>}
      {aiTab==="insights"&&<>
        <div style={{maxWidth:1000}}>
          <AiBtn label="Generate AI Performance Insight" loading={insightLoad} color={T.success} onClick={async()=>{
            setInsightLoad(true);setInsightText("");
            const r=await callClaude(`You are an automotive retail performance coach. Analyze ${displayName}'s data: Units ${UNITS_SOLD} of ${goalUnits}. Gross $${GROSS_MTD.toLocaleString()} of $${goalGross.toLocaleString()}. Customers: ${customers.length}. Hot leads: ${customers.filter(c=>c.status==="hot").length}. Closing ratio ${CLOSING_RATIO}%. Give 3 specific actionable coaching points under 200 words. Direct and motivating. Plain text.`);
            setInsightText(r);setInsightLoad(false);
          }}/>
          <div style={{display:"grid",gridTemplateColumns:isMobile?"1fr":"1fr 1fr",gap:16,marginTop:16}}>
            {insightText&&(
              <Card style={{border:`1px solid ${T.success}25`}}>
                <SecTitle text="AI Analysis" color={T.success}/>
                <div style={{fontSize:14,color:T.sub,lineHeight:1.85,whiteSpace:"pre-wrap"}}>{insightText}</div>
              </Card>
            )}
            <Card>
              <SecTitle text="Performance Summary"/>
              {[
                {label:"Units Delivered",value:`${UNITS_SOLD} / ${goalUnits}`,color:T.accent},
                {label:"Gross MTD",value:`$${(GROSS_MTD/1000).toFixed(1)}K / $${(goalGross/1000).toFixed(0)}K`,color:T.success},
                {label:"Total Customers",value:customers.length.toString(),color:T.blue},
                {label:"Hot Leads",value:customers.filter(c=>c.status==="hot").length.toString(),color:T.danger},
                {label:"Closing Ratio",value:`${CLOSING_RATIO}%`,color:T.blue},
                {label:"Vehicles on Lot",value:inventory.length.toString(),color:T.amber},
              ].map(s=>(
                <div key={s.label} style={{display:"flex",justifyContent:"space-between",padding:"10px 0",borderBottom:`1px solid ${T.border}`}}>
                  <div style={{fontSize:13,color:T.sub}}>{s.label}</div>
                  <div style={{fontSize:14,fontWeight:700,color:s.color}}>{s.value}</div>
                </div>
              ))}
            </Card>
          </div>
        </div>
      </>}
    </div>
  );

  const NAV=[
    {id:"home",label:"Home",icon:"⬡"},
    {id:"customers",label:"Clients",icon:"◎"},
    {id:"deals",label:"Deals",icon:"◈"},
    {id:"tools",label:"Tools",icon:"⊞"},
    {id:"ai",label:"Coaching",icon:"◉"},
  ];

  return(
    <div style={{background:T.bg,minHeight:"100vh",color:T.text,fontFamily:"'DM Sans',sans-serif",display:"flex",flexDirection:"column"}}>
      {!isMobile&&(
        <div style={{background:T.surface,borderBottom:`1px solid ${T.border}`,padding:"0 32px",display:"flex",alignItems:"center",justifyContent:"space-between",height:64,flexShrink:0,position:"sticky",top:0,zIndex:99}}>
          <div onClick={()=>navTo("home")} style={{fontSize:22,fontWeight:800,color:T.accent,letterSpacing:-0.5,cursor:"pointer"}}>⬡ DriveMind</div>
          <div style={{display:"flex",gap:4}}>
            {NAV.map(n=>(
              <button key={n.id} onClick={()=>navTo(n.id)} style={{background:tab===n.id?`${T.accent}15`:"none",border:`1px solid ${tab===n.id?T.accent:T.border}`,borderRadius:10,padding:"8px 20px",color:tab===n.id?T.accent:T.sub,cursor:"pointer",fontSize:14,fontWeight:tab===n.id?700:400,fontFamily:"inherit",display:"flex",alignItems:"center",gap:8}}>
                <span>{n.icon}</span>{n.label}
              </button>
            ))}
          </div>
          <div style={{display:"flex",alignItems:"center",gap:12}}>
            {user?(
              <div style={{position:"relative"}}>
                <button onClick={()=>setShowUserMenu(p=>!p)} style={{background:`${T.accent}15`,border:`1px solid ${T.accent}30`,borderRadius:100,padding:"8px 16px",color:T.accent,cursor:"pointer",fontSize:13,fontWeight:700,fontFamily:"inherit",display:"flex",alignItems:"center",gap:8}}>
                  👤 {user.name} ▾
                </button>
                {showUserMenu&&(
                  <div style={{position:"absolute",right:0,top:"calc(100% + 8px)",background:T.surface,border:`1px solid ${T.border}`,borderRadius:12,padding:8,minWidth:180,zIndex:200}}>
                    <div style={{padding:"8px 12px",fontSize:13,color:T.sub,borderBottom:`1px solid ${T.border}`,marginBottom:4}}>{user.email}</div>
                    <button onClick={onLogout} style={{width:"100%",background:"none",border:"none",padding:"10px 12px",color:T.danger,cursor:"pointer",fontSize:13,textAlign:"left",fontFamily:"inherit",borderRadius:8}}>Sign Out</button>
                  </div>
                )}
              </div>
            ):(
              <button onClick={onShowAuth} style={{background:T.accent,border:"none",borderRadius:100,padding:"8px 20px",color:"#fff",cursor:"pointer",fontSize:13,fontWeight:700,fontFamily:"inherit"}}>Sign In</button>
            )}
          </div>
        </div>
      )}
      {isMobile&&(
        <div style={{background:T.surface,borderBottom:`1px solid ${T.border}`,padding:"0 16px",display:"flex",alignItems:"center",justifyContent:"space-between",height:56,flexShrink:0,position:"sticky",top:0,zIndex:99}}>
          <div onClick={()=>navTo("home")} style={{fontSize:18,fontWeight:800,color:T.accent,cursor:"pointer"}}>⬡ DriveMind</div>
          {user?(
            <button onClick={onLogout} style={{background:`${T.danger}15`,border:`1px solid ${T.danger}30`,borderRadius:100,padding:"6px 12px",color:T.danger,cursor:"pointer",fontSize:12,fontWeight:600,fontFamily:"inherit"}}>Sign Out</button>
          ):(
            <button onClick={onShowAuth} style={{background:T.accent,border:"none",borderRadius:100,padding:"6px 14px",color:"#fff",cursor:"pointer",fontSize:12,fontWeight:700,fontFamily:"inherit"}}>Sign In</button>
          )}
        </div>
      )}
      <div style={{flex:1,overflowY:"auto",paddingBottom:isMobile?80:0}} onClick={()=>showUserMenu&&setShowUserMenu(false)}>
        {tab==="home"&&renderHome()}
        {tab==="customers"&&renderCustomers()}
        {tab==="deals"&&renderDeals()}
        {tab==="tools"&&renderTools()}
        {tab==="ai"&&renderAI()}
      </div>
      {isMobile&&(
        <div style={{position:"fixed",bottom:0,left:0,right:0,background:T.surface,borderTop:`1px solid ${T.border}`,display:"flex",zIndex:98}}>
          {NAV.map(n=>(
            <button key={n.id} onClick={()=>navTo(n.id)} style={{flex:1,background:"none",border:"none",padding:"10px 4px",cursor:"pointer",fontFamily:"inherit",display:"flex",flexDirection:"column",alignItems:"center",gap:3}}>
              <div style={{fontSize:20,color:tab===n.id?T.accent:T.muted}}>{n.icon}</div>
              <div style={{fontSize:10,color:tab===n.id?T.accent:T.muted,fontWeight:tab===n.id?700:400}}>{n.label}</div>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}